import moment from 'moment';

/**
 * Relative time (e.g. "3 hours ago") for the settings tables (Service accounts, API keys).
 * Returns '—' for a missing or unparseable value.
 */
export function formatRelative(value?: string): string {
  if (!value) return '—';
  const m = moment(value);
  return m.isValid() ? m.fromNow() : '—';
}

/**
 * Short display date (e.g. "Jan 5, 2026") for the settings tables (Service accounts, API keys).
 * Returns '—' for a missing or unparseable value.
 */
export function formatDate(value?: string): string {
  if (!value) return '—';
  const m = moment(value);
  return m.isValid() ? m.format('MMM D, YYYY') : '—';
}
